import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Table, Input, Typography, Card, Spin } from "antd";
import axios from "../../../components/utils/Interceptors";
import { toast } from "react-toastify";

const { Title } = Typography;
const { Search } = Input;

const Payout = () => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const [earnings, setEarnings] = useState([]);
    const [filterText, setFilterText] = useState("");
    const user = JSON.parse(localStorage.getItem("user"));

    useEffect(() => {
        const fetchEarnings = async () => {
            setLoading(true);
            try {
                const baseUrl = process.env.REACT_APP_APIURL;
                const res = await axios.get(`${baseUrl}/vendor/gettotalearnings`, {
                    headers: {
                        "Content-type": "application/json",
                        Authorization: `Bearer ${user.token}`,
                    },
                });

                const response = await res.data;

                if (response?.status_code === 200) {
                    setEarnings(response.data);
                } else {
                    setEarnings([]);
                }
            } catch (error) {
                toast.error(t("Failed to fetch earnings"));
            }
            setLoading(false);
        };

        fetchEarnings();
    }, [t, user.token]);

    const filteredItems = earnings.filter((item) =>
        item?.created_on?.toLowerCase().includes(filterText.toLowerCase())
    );

    const columns = [
        {
            title: t("order_table4"),
            dataIndex: "created_on",
            key: "created_on",
            sorter: (a, b) => a.created_on.localeCompare(b.created_on),
        },
        {
            title: t("Total_Earnings"),
            dataIndex: "total",
            key: "total",
        },
    ];

    return (
        <div>
            <Title level={4}>{t("income_total")}</Title>

            <Card className="mt-4">
                <Search
                    placeholder={t("Search by date")}
                    allowClear
                    onChange={(e) => setFilterText(e.target.value)}
                    style={{ marginBottom: 16 }}
                />

                {loading ? (
                    <div className="text-center py-10">
                        <Spin tip={t("Loading")} size="large" />
                    </div>
                ) : (
                    <Table
                        columns={columns}
                        dataSource={filteredItems}
                        rowKey="created_on"
                        pagination={{ pageSize: 10 }}
                        locale={{
                            emptyText: <span className="text-gray-400">{t("No records")}</span>,
                        }}
                    />
                )}
            </Card>
        </div>
    );
};

export default Payout;
